/**
 * Pivot Grouping (customOrderBases) group-by fields whose values are "<Name>:<value>": the report's field name is
 * shown in the column title ("Shipping Form Fields (Account Number)"). Must stay identical to the server list in
 * papaya/src/api/lib/constants/pivotFields.ts (papaya's pivotFields.sync.test.ts enforces it).
 */
export const PIVOT_NAMED_FIELDS = [
  'custom_fields',
  'customer_form_fields',
  'shipping_form_fields',
  'customer_custom_attributes',
  'product_metafields',
  'order_metafields',
  'options',
] as const

/** Column title for a pivot group-by field: the base title plus the chosen entry name for named fields. */
export const pivotColumnTitle = (field: string, entryName: string | undefined, baseTitle?: string): string | undefined =>
  entryName && (PIVOT_NAMED_FIELDS as readonly string[]).includes(field) ? `${baseTitle || field} (${entryName})` : undefined
